export const CAMERA_DEVICE_ID = 'camera_device_id';

export const WAREHOUSE_CONFIG = 'warehouse_config';
